import { Injectable } from "@angular/core";
import { BaseEntityService } from "../rest-common.service";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class TdspStaticService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  getStaticData(
    type: string,
    start_element: number = 0,
    num_elements: number = 300,
    params = {},
  ) {
    params["start_element"] = start_element;
    params["num_elements"] = num_elements;
    var url;
    url = this.buildUrl(
      `${this.BASE_TDSP_URL}/static/${type}/`,
      "",
      params
    );
    if (!type) {
      url = this.buildUrl(
        `${this.BASE_TDSP_URL}/static/geo/`,
        "",
        params
      );
    }
    return this.get(url);
  }

  getAllContexual(params={}){
    params={...params,table: 'tdsp_contextual_categories'}
    let url = this.buildUrl(`${this.BASE_TDSP_URL}/static/contextual-categories` , "", params);
    return this.get(url)
  }

  getAllInventoryCat(params={}){
    params={...params,table: 'tdsp_universal_categories'}
    let url = this.buildUrl(`${this.BASE_TDSP_URL}/static/inventory-categories` , "", {...params,cat_type: 'universal'});
    return this.get(url)
  }
}
